///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const WordIcon = ({
  height,
  fill,
  title = messages.word.defaultMessage,
  width,
  ...rest
}) => (
  <svg
    aria-labelledby="word-icon"
    height={height}
    viewBox="0 0 20 24"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title id="word-icon">{title}</title>
    <path
      fill={fill}
      fillRule="evenodd"
      d="M16.2,22 L1.8,22 C0.81,22 0,21.2016129 0,20.2258065 L0,1.77419355 C0,0.798387097 0.81,0 1.8,0 L9.126,0 C9.612,0 10.062,0.177419355 10.404,0.514516129 L17.478,7.48709677 C17.82,7.82419355 18,8.26774194 18,8.74677419 L18,20.2258065 C18,21.2016129 17.19,22 16.2,22 Z M1.8,0.709677419 C1.206,0.709677419 0.72,1.18870968 0.72,1.77419355 L0.72,20.2258065 C0.72,20.8112903 1.206,21.2903226 1.8,21.2903226 L16.2,21.2903226 C16.794,21.2903226 17.28,20.8112903 17.28,20.2258065 L17.28,8.74677419 C17.28,8.46290323 17.172,8.19677419 16.956,8.0016129 L9.882,1.02903226 C9.684,0.816129032 9.414,0.709677419 9.126,0.709677419 L1.8,0.709677419 Z"
      id="Shape"
      stroke={fill}
    />
    <path
      fill={fill}
      fillRule="nonzero"
      d="M11.646,16.6774194 L10.152,16.6774194 L9.324,13.483871 C9.288,13.3774194 9.234,13.1290323 9.162,12.7741935 C9.09,12.4193548 9.036,12.1709677 9.036,12.0645161 C9.018,12.2064516 8.982,12.4548387 8.91,12.7919355 C8.838,13.1290323 8.784,13.3596774 8.748,13.5016129 L7.92,16.6774194 L6.426,16.6774194 L4.86,10.5919355 L6.138,10.5919355 L6.93,13.9096774 C7.074,14.5306452 7.164,15.0451613 7.236,15.5064516 C7.254,15.3467742 7.29,15.0983871 7.344,14.7790323 C7.398,14.4596774 7.47,14.1935484 7.506,14.016129 L8.406,10.6096774 L9.648,10.6096774 L10.548,14.016129 C10.584,14.1758065 10.638,14.4064516 10.692,14.7080645 C10.746,15.0096774 10.8,15.2935484 10.836,15.5064516 C10.872,15.2935484 10.908,15.0274194 10.98,14.6903226 C11.052,14.3532258 11.106,14.1048387 11.142,13.9096774 L11.934,10.5919355 L13.212,10.5919355 L11.646,16.6774194 Z"
    />
  </svg>
);

export default WordIcon;
